"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = percentage;
function percentage(input) {
  return Math.round(input * 100);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-color-picker/lib/helpers/percentage.js
// module id = 1922
// module chunks = 0